// import React, { useEffect } from 'react'
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store'
// import { getWishlistByUserId } from '../../../Redux Toolkit/Customer/WishlistSlice';
// import WishlistProductCard from './WishlistProductCard';

// const Wishlist = () => {
//     const dispatch = useAppDispatch();
//     const { wishlist } = useAppSelector(store => store)


//     console.log("wishlist", wishlist)
//     return (
//         <div className='h-[85vh] p-5 lg:p-20'>
//             {wishlist.wishlist?.products.length ?
//                 <section>
//                     <h1><strong>My Wishlist</strong> {wishlist.wishlist.products.length} items</h1>
//                     <div className='pt-10 flex flex-wrap gap-5'>

//                         {wishlist.wishlist?.products?.map((item) => <WishlistProductCard item={item} />)}

//                     </div>
//                 </section> :
//                 <div className="h-full flex justify-center items-center flex-col">
//                     <div className="text-center py-5">
//                         <h1 className="text-lg font-medium">Hey it's feels so light!</h1>
//                         <p className="text-gray-500 text-sm">
//                             there is nothing in your wishlist, lets add some items
//                         </p>
//                     </div>

//                 </div>}
//         </div>
//     )
// }

// export default Wishlist


// import React from "react";
// import { Heart, ShoppingBag } from "lucide-react";
// import { useAppSelector } from "../../../Redux Toolkit/Store";
// import WishlistProductCard from "./WishlistProductCard";

// const Wishlist = () => {
//   const { wishlist } = useAppSelector((store) => store);

//   const wishlistItems = wishlist.wishlist?.products || [];

//   return (
//     <div className="min-h-[85vh] bg-white px-4 py-5 sm:px-6 lg:px-20">
//       <div className="mb-6 text-sm font-medium text-gray-700">
//         Home <span className="mx-2">&gt;</span> Wishlist
//       </div>

//       {wishlistItems.length ? (
//         <section>

//           <div>
//             <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
//               <div>
//                 <h1 className="text-xl font-semibold text-gray-900">
//                   My Wishlist ({wishlistItems.length})
//                 </h1>
//                 <p className="mt-1 text-sm text-gray-500">
//                   Items you love, all in one place.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 className="flex w-full items-center justify-center gap-2 rounded-md bg-gray-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-900 sm:w-auto"
//               >
//                 <ShoppingBag size={17} />
//                 Move All to Cart
//               </button>
//             </div>

//             <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
//               {wishlistItems.map((item: any) => (
//                 <WishlistProductCard key={item.id} item={item} />
//               ))}
//             </div>
//           </div>
//         </section>
//       ) : (
//         <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
//           <div className="mb-5 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100">
//             <Heart size={42} strokeWidth={1.8} />
//           </div>

//           <h1 className="text-lg font-semibold text-gray-900">
//             Hey, it feels so light!
//           </h1>
//           <p className="mt-2 text-sm text-gray-500">
//             There is nothing in your wishlist. Let’s add some items.
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Wishlist;




import React, { useEffect } from "react";
import { Heart } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { getWishlistByUserId } from "../../../Redux Toolkit/Customer/WishlistSlice";
import WishlistProductCard from "./WishlistProductCard";

const Wishlist = () => {
    const dispatch = useAppDispatch();
    const { wishlist } = useAppSelector((store) => store);

    const wishlistItems = [...(wishlist.wishlist?.products || [])].sort(
        (a: any, b: any) => (a.id || 0) - (b.id || 0)
    );

    useEffect(() => {
        dispatch(getWishlistByUserId());
    }, [dispatch]);

    return (
        <div className="min-h-[85vh] bg-white px-4 py-5 sm:px-6 lg:px-20">
            {wishlistItems.length ? (
                <section>
                    <div className="mb-6">
                        <h1 className="flex items-center gap-3 text-xl font-semibold text-gray-900">
                            <Heart size={22} />
                            My Wishlist ({wishlistItems.length})
                        </h1>
                        <p className="mt-1 text-sm text-gray-500">
                            Items you love, all in one place.
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-5">
                        {wishlistItems.map((item: any) => (
                            <WishlistProductCard key={item.id} item={item} />
                        ))}
                    </div>
                </section>
            ) : (
                <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
                    <Heart size={42} className="text-gray-300" />

                    <h1 className="mt-4 text-lg font-semibold text-gray-900">
                        Hey, it feels so light!
                    </h1>

                    <p className="mt-2 text-sm text-gray-500">
                        There is nothing in your wishlist. Let’s add some items.
                    </p>
                </div>
            )}
        </div>
    );
};

export default Wishlist;